import { render, staticRenderFns } from "./AmountModal.vue?vue&type=template&id=85d2df8c&scoped=true&"
import script from "./AmountModal.vue?vue&type=script&lang=js&"
export * from "./AmountModal.vue?vue&type=script&lang=js&"
import style0 from "./AmountModal.vue?vue&type=style&index=0&id=85d2df8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d2df8c",
  null
  
)

export default component.exports